import { createSelector } from 'reselect'

import { filtersSelector } from './filtersSelector'

export const selectedPortIdsSelector = createSelector(filtersSelector, filters => filters.ports)
